/**
=========================================================
* Argon Dashboard 2 PRO MUI - v3.0.0
=========================================================

* Property Page: https://www.creative-tim.com/property/argon-dashboard-pro-mui
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import Link from "@mui/material/Link";
import Icon from "@mui/material/Icon";

// Argon Dashboard 2 PRO MUI components
import ArgonBox from "components/ArgonBox";
import ArgonTypography from "components/ArgonTypography";

// Argon Dashboard 2 PRO MUI base styles
import typography from "assets/theme/base/typography";
import { useState, useEffect } from "react";
import AdministrationApi from "api/administrationApi";
function Footer({ company, links }) {
  const { href, name } = company;
  const { size } = typography;
  const administrationApi = new AdministrationApi();
  const [permitted, setPermitted] = useState(false);
  const attemptReachability = async () => {
    try {
      await administrationApi.getReachability();
      setPermitted(true);
      console.log("Permitted");
      // update links with { href: "https://www.hosthive.io/admin", name: "Admin"}
      let adminRoute = {
        href: "/administration/customers",
        name: "Administration",
        target: "_self",
      };
      // if name is not already in links, add it
      if (!links.find((link) => link.name === adminRoute.name)) {
        links.push(adminRoute);
      }
      // links.push();

      // getCompanies();
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    attemptReachability();
  }, []);

  const renderLinks = () =>
    links.map((link) => (
      <ArgonBox key={link.name} component="li" px={2} lineHeight={1}>
        <Link href={link.href} target={link.target ? link.target : "_blank"}>
          <ArgonTypography variant="button" fontWeight="regular" color="text">
            {link.name}
          </ArgonTypography>
        </Link>
      </ArgonBox>
    ));

  return (
    <ArgonBox
      width="100%"
      display="flex"
      flexDirection={{ xs: "column", lg: "row" }}
      justifyContent="space-between"
      alignItems="center"
      px={1.5}
    >
      <ArgonBox
        component="ul"
        sx={({ breakpoints }) => ({
          display: "flex",
          flexWrap: "wrap",
          alignItems: "center",
          justifyContent: "center",
          listStyle: "none",
          mt: 3,
          mb: 0,
          p: 0,

          [breakpoints.up("lg")]: {
            mt: 0,
          },
        })}
      >
        {renderLinks()}
      </ArgonBox>
    </ArgonBox>
  );
}

// Setting default values for the props of Footer
Footer.defaultProps = {
  company: { href: "https://www.hosthive.io/", name: "HostHive" },
  links: [
    { href: "https://www.hosthive.io/", name: "HostHive" },
    { href: "https://www.hosthive.io/product", name: "About Us" },
    { href: "https://www.hosthive.io/privacy", name: "Privacy Policy" },
    {
      href: "https://www.hosthive.io/terms-of-service",
      name: "Terms Of Service",
    },
  ],
};

// Typechecking props for the Footer
Footer.propTypes = {
  company: PropTypes.objectOf(PropTypes.string),
  links: PropTypes.arrayOf(PropTypes.object),
};

export default Footer;
